module.exports = __webpack_public_path__ + "static/sangmin_kim-516eec2a2a005449d59b61e2d46c37c8.png";